import React from "react";
import { useInvoiceActions } from "../../../hooks/useInvoiceActions";
import { useInvoice } from "../../../hooks/invoice/useInvoice";
import { ModalCharge } from "../../../shared/ModalCharge/ModalCharge";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { img } from "../../../../../../assets/img";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import { Input } from "../../../../../../shared/Input/Input";
import { InputError } from "../../../../../../shared/InputError/InputError";
import { InputPhone } from "../../../../../../shared/InputPhone/InputPhone";
import classes from "../scss/ViewChargeAffirm.module.scss";
import { Select } from "../../../../../../shared/Select/Select";
import { countriesOptions } from "./PaymentFormModal.utils";

const PaymentFormModal = ({ isTipsApplying, form, isLoading }) => {
  const { paymentViewClose } = useInvoiceActions();
  const { invoice } = useInvoice();
  const { tSales } = useAppTranslation.Sales();
  const { tCommon } = useAppTranslation.Common();

  const { values, handleSubmit, setFieldValue, errors, handleBlur, touched } =
    form;

  return (
    <ModalCharge
      isOpen
      onClose={paymentViewClose}
      title={tSales("checkoutInvoice.paymentOptions.affirm")}
      imageSrc={img.affirm}
      imageClassName={classes.titleIcon}
      onCharge={handleSubmit}
      isCharging={isLoading}
      isChargeDisabled={isTipsApplying}
      chargeLabel={tCommon("label.continue")}
    >
      <ModalCharge.InputWrap>
        <InputLabel>{tSales("checkoutInvoice.formInputLabel.mail")}</InputLabel>
        <Input
          type="email"
          size="small"
          name="email"
          value={values.email}
          isError={Boolean(errors.email) && Boolean(touched.email)}
          onChange={(e) => setFieldValue("email", e.target.value)}
          onBlur={handleBlur}
          placeholder={tCommon("formPlaceholder.email")}
          isDisabled={Boolean(invoice?.patient?.email)}
        />
        {Boolean(errors.email) && Boolean(touched.email) && (
          <InputError>{errors.email}</InputError>
        )}
      </ModalCharge.InputWrap>
      <ModalCharge.InputWrap>
        <InputLabel>
          {tSales("checkoutInvoice.formInputLabel.phoneNumber")}
        </InputLabel>
        <InputPhone
          withSearch
          fullWidth
          variant="legacy-outlined"
          value={values.phoneNumber}
          onChange={(value, country, e, formattedPhone) => {
            setFieldValue("phoneNumber", formattedPhone);
          }}
          onBlur={handleBlur}
          inputProps={{ name: "phoneNumber" }}
          isError={Boolean(errors.phoneNumber) && Boolean(touched.phoneNumber)}
        />
        {Boolean(errors.phoneNumber) && Boolean(touched.phoneNumber) && (
          <InputError>{errors.phoneNumber}</InputError>
        )}
      </ModalCharge.InputWrap>
      <ModalCharge.InputWrap>
        <InputLabel>
          {tSales("checkoutInvoice.formInputLabel.country")}
        </InputLabel>
        <Select
          name="country"
          size="small"
          value={values.country}
          options={countriesOptions}
          onChange={(value) => setFieldValue("country", value)}
        />
      </ModalCharge.InputWrap>
    </ModalCharge>
  );
};

export default PaymentFormModal;
